<template>
  <div v-if="mounted" class="generate-pdf">
    <header>
      <p>RELATÓRIO DA PESQUISA DE SATISFAÇÃO DO CLIENTE</p>
      <button class="generate-pdf__button-send-email" @click="generatePdf">
        Enviar por email
      </button>
    </header>

    <div v-show="sendLoading" class="generate-pdf__loading-send-email">
      <div
        class="generate-pdf__loading-send-email-wrapper"
        v-show="typeLoading === 'progress'"
      >
        <p>
          {{ currentPage }}
        </p>

        <div
          :class="[
            'generate-pdf__loading-send-email-wrapper-progress-bar',
            `generate-pdf__loading-send-email-wrapper-progress-bar--${currentPercentage}`
          ]"
        />

        <p>{{ totalPages }}</p>
      </div>

      <Feather
        class="loading__icon"
        type="loader"
        animation="spin"
        v-show="typeLoading === 'spin'"
      />

      <p class="generate-pdf__loading-send-email-text">{{ loadingMessage }}</p>
    </div>

    <div class="report">
      <div class="report-view report-view--hero">
        <div class="report-view__wrapper-logo" />

        <div class="report-view__wrapper">
          <p class="report-view__title">
            RELATÓRIO DA PESQUISA DE SATISFAÇÃO DO CLIENTE
          </p>

          <img
            src="/img/miconta-logo-landscape.png"
            class="report-view__logo-miconta"
          />

          <p class="report-view__description-customer">
            Cliente: {{ reports.customer.company_name }} -
            {{ this.capitalize(this.$moment().format("MMMM[/]YYYY")) }}
          </p>

          <img
            class="report-view__logo-customer report-view__logo-customer--center"
            :src="reports.customer.logo"
          />
        </div>
      </div>

      <div class="report-view">
        <div class="report-view__wrapper-logo">
          <img src="/img/logo.png" class="report-view__logo" />
        </div>

        <div class="report-view__wrapper">
          <p class="report-view__title">
            RELATÓRIO DA PESQUISA DE SATISFAÇÃO DO CLIENTE
          </p>

          <p class="report-view__sub-title">
            Total de avaliações
          </p>

          <div id="total-question" style="width: 100%;height: 55%;" />

          {{ initChartTotalQuestions(reports.answers_by_month) }}

          <img
            class="report-view__logo-customer"
            :src="reports.customer.logo"
          />
        </div>
      </div>

      <section>
        <div
          class="report-view"
          v-for="question in mapQuestions(reports.questions)"
          :key="question.uuid"
        >
          <div class="report-view__wrapper-logo">
            <img src="/img/logo.png" class="report-view__logo" />
          </div>

          <div class="report-view__wrapper" v-if="isChartPage(question)">
            <p class="report-view__title">
              RELATÓRIO DA PESQUISA DE SATISFAÇÃO DO CLIENTE
            </p>
            <p class="report-view__sub-title">
              {{ question.question }}
            </p>

            <div :id="btoa(question.uuid)" style="width: 100%;height: 55%;" />

            {{ initChartByQuestion(question) }}

            <img
              class="report-view__logo-customer"
              :src="reports.customer.logo"
            />
          </div>

          <div
            class="report-view__wrapper"
            v-else-if="question.responses.length > 0"
          >
            <p class="report-view__title">
              RELATÓRIO DA PESQUISA DE SATISFAÇÃO DO CLIENTE
            </p>
            <p class="report-view__sub-title">
              {{ question.question.question }}
            </p>

            <section style="width: 100%">
              <div class="row">
                <div
                  class="col"
                  v-for="quote in question.responses"
                  :key="quote.uuid"
                >
                  <div class="report-view__wrapper-quote">
                    <p class="report-view__quote">“{{ quote.response }}”</p>

                    <p class="report-view__quote-author">
                      {{ quote.name || "Sem Identificação" }}
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <img
              class="report-view__logo-customer"
              :src="reports.customer.logo"
            />
          </div>
        </div>
      </section>

      <div class="report-view">
        <div class="report-view__wrapper-logo">
          <img src="/img/logo.png" class="report-view__logo" />
        </div>

        <div class="report-view__wrapper">
          <p class="report-view__title">
            RELATÓRIO DA PESQUISA DE SATISFAÇÃO DO CLIENTE
          </p>
          <p class="report-view__text-feedback">
            Mi.Conta agradece sua atenção e estamos a disposição para lhe ajudar
            no que se refere à interpretação dos dados e auxilia-lo nas tomadas
            de decisões.
          </p>

          <div class="report-view__wrapper-quote-miconta">
            <p class="report-view__quote-miconta">
              “A melhor propaganda é feita por Clientes satisfeitos”
            </p>
            <p class="report-view__quote-author-miconta">
              Philip Kotler
            </p>
          </div>

          <img
            class="report-view__logo-customer"
            :src="reports.customer.logo"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="loading" v-else>
    <Feather class="loading__icon" type="loader" animation="spin" />

    <p class="loading__text">Buscando relatório...</p>
  </div>
</template>

<script>
import { jsPDF } from "jspdf";
import { toPng } from "html-to-image";
import Feather from "vue-feather";

import { mapState } from "vuex";

const typesByGroupMonth = [
  "BOOLEAN",
  "CHOICES",
  "CHECK_BOXES",
  "LINEAR_SCALE",
  "LINER_SCALE", // Typo from backend
  "DROPDOWN"
];

export default {
  name: "generatePdf",
  components: { Feather },
  data: () => ({
    mounted: false,
    reports: {},
    sendLoading: false,
    loadingMessage: "",
    progress: 0,
    currentPage: 1,
    totalPages: 1,
    typeLoading: "progress"
  }),
  props: {
    uuid: {
      type: String,
      default: ""
    }
  },
  async mounted() {
    document.body.style = "overflow: hidden;";

    await this.getReportApiAsnc();

    google.charts.load("current", { packages: ["corechart"] });

    setTimeout(() => {
      this.mounted = true;
    });
  },
  beforeDestroy() {
    document.body.style = "overflow: auto;";
  },
  computed: {
    ...mapState("User", ["token"]),
    currentPercentage() {
      const percent = (this.currentPage / this.totalPages) * 100;

      return this.round(percent, -1);
    }
  },
  methods: {
    async getReportApiAsnc() {
      try {
        const response = await this.$http.get(`reports/export/${this.uuid}`, {
          headers: {
            Authorization: this.token
          }
        });

        this.reports = response.body.data;
      } catch (err) {
        console.error(err);
      }
    },
    round(number, precision) {
      var factor = Math.pow(10, precision);
      var tempNumber = number * factor;
      var roundedTempNumber = Math.round(tempNumber);
      return roundedTempNumber / factor;
    },
    async generatePdf() {
      this.sendLoading = true;

      const filename = `Relatório de Satisfação do Cliente - ${
        this.reports.customer.company_name
      } - ${this.capitalize(this.$moment().format("MMMM[/]YYYY"))}.pdf`;

      this.currentPage = 1;

      this.loadingMessage = "Gerando pdf, por favor aguarde...";

      const listViewElement = this.$el.querySelectorAll(".report-view");

      this.totalPages = listViewElement.length;

      let pdf = new jsPDF("l", "mm", "a4", true);

      for (let viewEntry of Object.entries(listViewElement)) {
        const [key, view] = viewEntry;

        const dataUrl = await toPng(view);

        if (key > 0) pdf.addPage("a4", "l");

        pdf.addImage(dataUrl, "PNG", 0, 0, 298, 211);

        this.currentPage = this.currentPage + 1;
      }

      this.loadingMessage = "Enviando para email...";
      this.typeLoading = "spin";

      await this.sendEmail(pdf.output("datauristring", filename));

      this.sendLoading = false;

      this.$swal({
        title: "Pronto!",
        text: "Email enviado com sucesso",
        icon: "success"
      });
    },
    async sendEmail(base64) {
      return this.$http.post("reports/send", {
        report: {
          customer: {
            uuid: this.reports.customer.uuid
          },
          attachment: base64
        }
      });
    },
    capitalize(string) {
      if (typeof string !== "string") return "";

      const newString = string.toLowerCase();

      return newString.charAt(0).toUpperCase() + newString.slice(1);
    },
    isChartPage(question) {
      return typesByGroupMonth.includes(question.type_response);
    },
    showPage(question) {
      return this.isChartPage(question)
        ? Object.keys(question.grouped_by_month).length > 0
        : true;
    },
    mapQuestions(questions) {
      return questions.reduce((acc, curr) => {
        if (this.showPage(curr)) {
          return [...acc, curr];
        }

        return acc;
      }, []);
    },
    initChartByElementAndContext(elementChart, context) {
      google.charts.setOnLoadCallback(() => {
        const { key, legends, content, options } = context;

        var data = google.visualization.arrayToDataTable([
          [key, ...legends],
          ...content
        ]);

        var chart = new google.visualization.ColumnChart(elementChart);

        chart.draw(data, options);
      });
    },
    initChartTotalQuestions(answers_by_month) {
      this.$nextTick(() => {
        const element = document.querySelector(`#total-question`);

        const content = Object.keys(answers_by_month).map(month => {
          return [
            this.capitalize(month),
            answers_by_month[month],
            answers_by_month[month]
          ];
        });

        const legends = [
          "Total de avaliações",
          { type: "string", role: "annotation" }
        ];

        var options = {
          series: {
            0: { targetAxisIndex: 0 }
          },
          chartArea: { width: "80%" },
          legend: {
            position: "bottom",
            maxLines: 3
          },
          annotations: {
            textStyle: {
              fontSize: 16,
              auraColor: "none",
              color: "#000"
            }
          },
          vAxis: { minValue: 0 }
        };

        const context = {
          key: "total-question",
          legends,
          content,
          options
        };

        this.initChartByElementAndContext(element, context);
      });
    },
    initChartByQuestion(question) {
      this.$nextTick(() => {
        const element = document.querySelector(`#${btoa(question.uuid)}`);

        // Calculate maxValueLine
        const maxValueLine = Object.entries(question.totals).reduce(
          (acc, curr) => {
            const [month, value] = curr;
            return acc + value;
          },
          0
        );
        
        let legends, content;
        
        // For LINEAR_SCALE questions, filter out responses with zero values
        if (question.type_response === "LINEAR_SCALE" || question.type_response === "LINER_SCALE") {
          // Find which responses have non-zero values across all months
          const allMonths = Object.keys(question.grouped_by_month);
          const nonZeroIndices = question.responses.reduce((indices, response, index) => {
            const hasNonZero = allMonths.some(month => {
              const monthData = question.grouped_by_month[month];
              return monthData && monthData[index] > 0;
            });
            if (hasNonZero) {
              indices.push(index);
            }
            return indices;
          }, []);
          
          // Filter legends and content based on non-zero indices
          legends = [];
          for (const index of nonZeroIndices) {
            const response = question.responses[index];
            legends.push(String(response));
            legends.push({ type: "string", role: "annotation" });
          }
          
          content = Object.entries(question.grouped_by_month).map(curr => {
            const bars = [];
            for (const index of nonZeroIndices) {
              const value = curr[1][index];
              bars.push(value);
              bars.push(`${this.percentByValueAndMaxValue(value, maxValueLine)}%`);
            }
            return [this.capitalize(curr[0]), ...bars];
          });
        } else {
          // For other question types, use all responses
          legends = [];
          for (const response of question.responses) {
            legends.push(String(response));
            legends.push({ type: "string", role: "annotation" });
          }
          
          content = Object.entries(question.grouped_by_month).map(curr => {
            const bars = [];
            for (const value of curr[1]) {
              bars.push(value);
              bars.push(`${this.percentByValueAndMaxValue(value, maxValueLine)}%`);
            }
            return [this.capitalize(curr[0]), ...bars];
          });
        }

        const options = {
          series: {
            0: { targetAxisIndex: 0 }
          },
          chartArea: { width: "80%" },
          legend: {
            position: "bottom",
            maxLines: 3
          },
          annotations: {
            textStyle: {
              fontSize: 16,
              auraColor: "none",
              color: "#000"
            }
          },
          vAxis: { minValue: 0, maxValue: maxValueLine }
        };

        const context = {
          key: question.uuid,
          legends,
          content,
          options
        };

        this.initChartByElementAndContext(element, context);
      });
    },
    percentByValueAndMaxValue(value, maxValue) {
      return Math.round((Number(value) / maxValue) * 100);
    },
    btoa(value) {
      return btoa(value);
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/components/utils";

@function percentProgressBar($progress) {
  @return $progress * 1%;
}

@function borderRadiusProgressBar($progress) {
  $radiusCycle: 4px;
  $radiusSemiCycle: 4px 0 0 4px;

  @if $progress == 100 {
    @return $radiusCycle;
  }

  @return $radiusSemiCycle;
}

.generate-pdf {
  background: #8a8a8a;

  header {
    background: #323639;
    padding: 12px 32px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 16px 24px rgb(0 0 0 / 6%);
    align-items: center;

    p {
      color: #fff;
      margin: 0;
      font-weight: 600;
    }
  }

  &__button-send-email {
    background: #fff;
    color: #546e7a;
    border: 1.2px solid #cfd8dc;
    outline: none;
    padding: 0 24px;
    height: 36px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 15px;
    box-sizing: border-box;
    cursor: pointer;
    z-index: 6;

    &:focus {
      background-color: #fff;
    }
  }

  &__loading-send-email {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    position: fixed;
    background: rgba(255, 255, 255, 0.8);
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;

    &-icon {
      width: 32px;
      color: #656565;
      margin-bottom: 16px;
      svg {
        stroke-width: 2.5;
      }
    }

    &-text {
      font-size: 18px;
      margin: 0;
      color: #656565;
    }

    &-wrapper {
      display: flex;
      align-items: center;
      &-progress-bar {
        height: 6px;
        background: #e0e0e0;
        margin: 8px 0;
        position: relative;
        border-radius: 4px;

        width: 30vw;
        margin: 16px;

        &:before {
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          content: "";
          transition: width 0.5s ease-out;

          background-color: #10be10;
        }
      }

      @for $i from 0 through 100 {
        &-progress-bar--#{$i} {
          &:before {
            width: percentProgressBar($i);
            border-radius: borderRadiusProgressBar($i);
          }
        }
      }
    }
  }
}

.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  &__icon {
    width: 32px;

    margin-bottom: 16px;
    svg {
      stroke-width: 2.5;
    }
  }

  &__text {
    font-size: 18px;
    margin: 0;
  }
}

@page {
  margin: 0cm;
  size: landscape;
}

p {
  widows: 3;
  orphans: 3;
}

.report {
  margin: 0;
  padding: 24px;
  background: #8a8a8a !important;
  overflow: auto;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;

  .chartjs-size-monitor {
    width: 100% !important;
    height: 100% !important;

    canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }

  &-view {
    height: px(21cm);
    width: px(29.7cm);
    background: #fff;
    margin-bottom: 24px;
    display: flex;
    flex-shrink: 0;

    &__wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding: 0 56px;
    }

    &__text-feedback {
      position: absolute;
      top: 40%;
      transform: translateY(-50%);
      max-width: 89%;
      font-size: 24px;
      text-align: center;
      margin: 0;
    }

    &__wrapper-quote-miconta {
      position: absolute;
      bottom: 170px;
    }

    &__quote-miconta {
      font-weight: 600;
      font-size: 18px;
      font-style: italic;
      margin: 0 0 4px 0;
    }

    &__quote-author-miconta {
      margin: 0;
      text-align: center;
    }

    &__title {
      font-size: 24px;
      font-weight: bold;
      margin: 56px 0 40px 0;
    }

    &--hero &__title {
      font-size: 32px;
      margin: 56px 0 86px 0;
    }

    &__logo-miconta {
      height: 120px;
    }

    &__description-customer {
      color: #8e8e8e;
      font-weight: 500;
      font-size: 24px;
      margin: 96px 0 72px 0;
    }

    &__sub-title {
      margin: 0 0 40px;
      font-size: 18px;
    }

    &__wrapper-quote {
      align-self: flex-start;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &__quote {
      margin: 0 0 8px 0;
      font-style: italic;
      max-width: 280px;
      text-align: center;

      &-author {
        margin: 0;
        font-weight: 600;
      }
    }

    &__logo-customer {
      height: 96px;

      &:not(&--center) {
        position: absolute;
        bottom: 32px;
        right: 32px;
      }

      &--center {
        height: 200px;
      }
    }

    &__wrapper-logo {
      width: 150px;
      background: rgba(248, 185, 72, 1);
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: flex-start;
    }

    &__logo {
      width: 80%;
      margin-top: 16px;
    }

    page-break-after: always;
  }
}

@media print {
  .report {
    margin: 0;
    padding: 0;
    display: block;
    background: #fff;

    &-view {
      margin-bottom: 0;

      width: 100vw;
      height: 100vh;
    }
  }
}
</style>
